<section class="ui-error-state" role="alert">
  <div class="ui-error-state-icon" aria-hidden="true">!</div>
  <div class="ui-error-state-copy">
    <h2 class="ui-error-state-title">{{ title() }}</h2>
    @if (hasDescription()) {
      <p class="ui-error-state-description">{{ description() }}</p>
    }
  </div>
  @if (hasAction()) {
    <ui-button size="sm" variant="secondary" (pressed)="handleActionSelected()">
      {{ actionLabel() }}
    </ui-button>
  }
</section>
